<template>
  <div>
    <NewNavbar variant="standard" />
    <nuxt />
    <OFooter
      :locale="locale"
      :year="$moment().format('YYYY')"
      :faq-column="footer.faqColumn"
      :how-does-it-work-column="footer.howDoesItWorkColumn"
      :legal-column="footer.legalColumn"
    />
  </div>
</template>

<script>
import { authenticated } from '@/mixins/layouts'
import footer from '@/mixins/footer'
import NewNavbar from '@/components/NewNavbar'
import OFooter from '@/components/OFooter'

export default {
  name: 'CustomerServiceLayout',
  middleware: 'homepage',
  components: {
    NewNavbar,
    OFooter
  },
  mixins: [authenticated, footer]
}
</script>

<style lang="postcss" scoped>
.chat-mobile {
  @apply absolute;
  right: 4rem;
  top: 12rem;
}

.chat-desktop {
  @apply absolute;
  right: 10rem;
  top: 2rem;
}
</style>
